import {TestState, TestResults, Answer, Question} from 'Models';
import AbstractModel from '../models/AbstractModel';

/*
 * Class wraps TestState and TestResults for convenience,
 * when handling a test as a whole.
 */
export class TestData extends AbstractModel {
    // constructor() { super({}); }


    //#region Static Methods
        static hasStarted()     { return TestState.hasStarted(); }
        static hasEnded()       { return TestState.hasEnded(); }
        static isTestRunning()  { return TestState.isRunning(); }
        static isRealTest()     { return TestState.isRealTest(); }
        static isExercise()    { return !TestState.isRealTest(); }


        static changeModeTo(mode) {
            let isRealTest = mode==='Testmodus';

            this.resetAll(isRealTest);

            if(isRealTest)
                this.setToRealTest();
            else
                this.setToExercise();
        }

        static setToRealTest()  {
            let isRealTest = true;
            TestState.reset(isRealTest);
            TestResults.initResultsState(isRealTest);
        }

        static startRealTest() {
            let isRealTest = true;
            TestResults.initResultsState(isRealTest);
            TestState.startTest(isRealTest);
        }

        static stopRealTest(isCancelled=false) {
            let isRealTest = true;
            TestState.endTest();
            TestResults.finalizeResultsState(isCancelled, isRealTest);
        }


        static setToExercise()  {
            let isRealTest = false;
            TestState.reset(isRealTest);
            TestResults.initResultsState(isRealTest);
        }

        static startExercise() {
            TestResults.initResultsState()
            TestState.startTest()
        }

        static stopExercise(isCancelled=false) {
            TestState.endTest();
            TestResults.finalizeResultsState(isCancelled);
        }


        static resetAll(isRealTest=false) {
            TestState.reset(isRealTest)
            TestResults.reset()
            Question.setSelectedIndexTo(0)
            Answer.setSelectedUserAnswerIndex(0)
        }
    //#endregion Static Methods
}
